module.exports = __webpack_public_path__ + "a2cbec4b96976bde29e7d9d67a2cd527.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_5.png
// module id = 1799
// module chunks = 1